const state = () => ({
  tariffSelected: null,
  contactDialog: false,
  family: false,
  fastReply: false,
  step: 1,
  companySize: 2,
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  dialogButtons: []
});

const getters = {
  tariffSelected(state) {
    return state.tariffSelected;
  },
  contactDialog(state) {
    return state.contactDialog;
  },
  family(state) {
    return state.family;
  },
  fastReply(state) {
    return state.fastReply;
  },
  step(state) {
    return state.step;
  },
  companySize(state) {
    return state.companySize;
  },
  utm_source(state) {
    return state.utm_source;
  },
  utm_medium(state) {
    return state.utm_medium;
  },
  utm_campaign(state) {
    return state.utm_campaign;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  }
};

const mutations = {
  setTariffSelected(state, results) {
    state.tariffSelected = results;
  },
  setContactDialog(state, results) {
    state.contactDialog = results;
  },
  setFamily(state, results) {
    state.family = results;
  },
  setFastReply(state, results) {
    state.fastReply = results;
  },
  setStep(state, results) {
    state.step = results;
  },
  setCompanySize(state, payload) {
    state.companySize = payload;
  },
  setUtm(state, payload) {
    state.utm_source = payload.utm_source;
    state.utm_medium = payload.utm_medium;
    state.utm_campaign = payload.utm_campaign;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  }
};

const actions = {
  setCompanySize({ commit }, payload) {
    commit('setCompanySize', payload);
  },
  setFamily({ commit }, payload) {
    commit('setFamily', payload);
  },
  setFastReply({ commit }, payload) {
    commit('setFastReply', payload);
  },
  setTariffSelected({ commit }, payload) {
    commit('setFastReply', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  }
};

export const forCompanies = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
